"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AuthModule () {
        return AuthModule;
    },
    get authModuleMetadata () {
        return authModuleMetadata;
    }
});
const _common = require("@nestjs/common");
const _passport = require("@nestjs/passport");
const _nocomodule = require("~/modules/noco.module");
const _basicstrategy = require("~/strategies/basic.strategy/basic.strategy");
const _localstrategy = require("~/strategies/local.strategy");
const _authtokenstrategy = require("~/strategies/authtoken.strategy/authtoken.strategy");
const _oauthtokenstrategy = require("~/strategies/oauth-token.strategy");
const _baseviewstrategy = require("~/strategies/base-view.strategy/base-view.strategy");
const _googlestrategy = require("~/strategies/google.strategy/google.strategy");
const _authservice = require("~/modules/auth/auth.service");
const _authcontroller = require("~/modules/auth/auth.controller");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
const authModuleMetadata = {
    imports: [
        _passport.PassportModule,
        _nocomodule.NocoModule
    ],
    controllers: [
        ...process.env.NC_WORKER_CONTAINER !== 'true' ? [
            _authcontroller.AuthController
        ] : []
    ],
    providers: [
        _authservice.AuthService,
        _localstrategy.LocalStrategy,
        _authtokenstrategy.AuthTokenStrategy,
        _oauthtokenstrategy.OAuthTokenStrategy,
        _baseviewstrategy.BaseViewStrategy,
        _basicstrategy.BasicStrategy,
        _googlestrategy.GoogleStrategyProvider
    ],
    exports: []
};
let AuthModule = class AuthModule {
};
AuthModule = _ts_decorate([
    (0, _common.Module)(authModuleMetadata)
], AuthModule);
